webpackJsonp([8],{

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setAuth;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAuth;
/* harmony export (immutable) */ __webpack_exports__["a"] = authorizeRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__localStorage__ = __webpack_require__(150);
/* eslint-disable import/prefer-default-export */

function setAuth(id, username, email, password, phone, verified, addresses, meta, gender, industry, dateOfBirth, profilePhoto) // new
{
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.id', id);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.username', username);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.email', email);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.password', password);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.phone', phone);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.verified', verified);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.addresses', addresses);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.gender', gender);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.industry', industry);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.date_of_birth', dateOfBirth);
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.profile_photo', profilePhoto);

  if (meta != null) {
    Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.has_agreed_to_receive_gogovan_updates', meta.has_agreed_to_receive_gogovan_updates);
    Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["d" /* localStorageSet */])('auth.has_agreed_to_receive_third_parties_updates', meta.has_agreed_to_receive_third_parties_updates);
  }

  return this;
}
function getAuth() {
  var email = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.email', false);
  var password = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.password', false);
  var phone = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.phone', false);

  if (!((email || phone) && password)) {
    return false;
  }

  var id = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.id', false);
  var username = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.username', false);
  var verified = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.verified', false);
  var addresses = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.addresses', false);
  var gender = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.gender', false);
  var industry = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.industry', false);
  var dateOfBirth = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.date_of_birth', false);
  var receiveGogovanUpdates = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.has_agreed_to_receive_gogovan_updates', false);
  var receiveThirdPartiesUpdates = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.has_agreed_to_receive_third_parties_updates', false);
  var profilePhoto = Object(__WEBPACK_IMPORTED_MODULE_0__localStorage__["b" /* localStorageGet */])('auth.profile_photo', false);
  return {
    id: id,
    email: email,
    password: password,
    username: username,
    phone: phone,
    verified: verified,
    addresses: addresses,
    profilePhoto: profilePhoto,
    receiveGogovanUpdates: receiveGogovanUpdates,
    receiveThirdPartiesUpdates: receiveThirdPartiesUpdates,
    gender: gender,
    industry: industry,
    dateOfBirth: dateOfBirth
  };
}
function authorizeRequest(json) {
  var auths = '';

  if (json === null) {
    auths = btoa("".concat(getAuth().email, ":").concat(getAuth().password)); // auths = Buffer.from(`${getAuth().email}:${getAuth().password}`).toString('base64');
  } else {
    auths = btoa("".concat(json.user.email, ":").concat(json.user.password));
  }

  return "Basic ".concat(auths);
}

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = localStorageSet;
/* harmony export (immutable) */ __webpack_exports__["b"] = localStorageGet;
/* harmony export (immutable) */ __webpack_exports__["a"] = localStorageClear;
/* harmony export (immutable) */ __webpack_exports__["c"] = localStorageRemove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_store__);
/* eslint-disable import/prefer-default-export */
// LocalStorage handler

var exp = 1000 * 60 * 24 * 10; // 10 days

/**
 * set
 * @param {String} key
 * @param {Object} val
 */

function localStorageSet(key, val) {
  __WEBPACK_IMPORTED_MODULE_0_store___default.a.set(key, {
    val: val,
    exp: exp,
    time: new Date().getTime()
  });
}
/**
 * get
 * @param  {String} key
 * @return {Object}
 */

function localStorageGet(key) {
  var info = __WEBPACK_IMPORTED_MODULE_0_store___default.a.get(key);

  if (!info) {
    return null;
  }

  if (new Date().getTime() - info.time > info.exp) {
    return null;
  }

  return info.val;
}
/**
 * Clear all stored data
 * @return {null}
 */

function localStorageClear() {
  __WEBPACK_IMPORTED_MODULE_0_store___default.a.clearAll();
}
function localStorageRemove(item) {
  __WEBPACK_IMPORTED_MODULE_0_store___default.a.remove(item);
}

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
// type Fetch = (url: string, options: ?any) => Promise<any>;

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
function createFetch(_ref) {
  var cookie = _ref.cookie,
      locale = _ref.locale;
  var baseUrl = "https://a.gogovan.hk"; // let baseUrl = 'https://dev-hk.gogovanapp.com';

  var currentLocale = locale;

  switch (locale) {
    case 'en-HK':
      currentLocale = 'en_US';
      break;

    case 'zh-HK':
      currentLocale = 'zh_TW';
      break;

    case 'zh-TW':
      currentLocale = 'zh_TW';
      baseUrl = "https://a.gogovan.tw"; // baseUrl = 'https://dev-tw.gogovanapp.com';

      break;

    case 'en-SG':
      currentLocale = 'en_SG';
      baseUrl = "https://a.gogovan.sg"; // baseUrl = 'https://dev-sg.gogovanapp.com';

      break;

    case 'ko-KR':
      baseUrl = "https://a.gogovan.co.kr"; // baseUrl = 'https://dev-kr.gogovanapp.com';

      break;

    case 'en-IN':
      currentLocale = 'en_IN';
      baseUrl = "https://a.gogovan.co.in"; // baseUrl = 'https://dev-in.gogovanapp.com';

      break;

    default:
      break;
  }

  var defaults = {
    method: 'POST',
    // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    'X-Requested-With': null,
    headers: _extends({
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': null,
      'GoGoVan-User-Language': currentLocale
    }, cookie ? {
      Cookie: cookie
    } : null)
  };

  var result = function result(url, options) {
    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch("".concat(baseUrl).concat(url), _extends({}, defaults, options, {
      headers: _extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (createFetch);

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
 // Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history

/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIntl;
/* harmony export (immutable) */ __webpack_exports__["c"] = setLocale;
/* harmony export (immutable) */ __webpack_exports__["b"] = setIsdefaultLang;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_graphql__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__intl_graphql__);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/* eslint-disable import/prefer-default-export */




function getIntlFromState(state) {
  var intl = state && state.intl || {};
  var initialNow = intl.initialNow,
      locale = intl.locale,
      messages = intl.messages;
  var localeMessages = messages && messages[locale] || {};
  var provider = new __WEBPACK_IMPORTED_MODULE_0_react_intl__["a" /* IntlProvider */]({
    initialNow: initialNow,
    locale: locale,
    messages: localeMessages,
    defaultLocale: 'ko-KR'
  });
  return provider.getChildContext().intl;
}

function getIntl() {
  return function (dispatch, getState) {
    return getIntlFromState(getState());
  };
}
function setLocale(_ref) {
  var locale = _ref.locale;
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
        var client, history, _ref4, data, messages, maxAge;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = _ref2.client, history = _ref2.history;
                dispatch({
                  type: __WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* SET_LOCALE_START */],
                  payload: {
                    locale: locale
                  }
                });
                _context.prev = 2;
                _context.next = 5;
                return client.query({
                  query: __WEBPACK_IMPORTED_MODULE_2__intl_graphql___default.a,
                  variables: {
                    locale: locale
                  }
                });

              case 5:
                _ref4 = _context.sent;
                data = _ref4.data;
                messages = data.intl.reduce(function (msgs, msg) {
                  msgs[msg.id] = msg.message; // eslint-disable-line no-param-reassign

                  return msgs;
                }, {});
                dispatch({
                  type: __WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* SET_LOCALE_SUCCESS */],
                  payload: {
                    locale: locale,
                    messages: messages
                  }
                }); // remember locale for every new request

                if (true) {
                  maxAge = 3650 * 24 * 3600; // 10 years in seconds

                  document.cookie = "lang=".concat(locale, ";path=/;max-age=").concat(maxAge);
                  history.push("?lang=".concat(locale));
                } // return bound intl instance at the end


                return _context.abrupt("return", getIntlFromState(getState()));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                dispatch({
                  type: __WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* SET_LOCALE_ERROR */],
                  payload: {
                    locale: locale,
                    error: _context.t0
                  }
                });
                return _context.abrupt("return", null);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}
function setIsdefaultLang(bool) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* IS_DEFAULT_LANG */],
      payload: bool
    });
  };
}

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(164);
module.exports = __webpack_require__(363);


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SET_RUNTIME_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SET_LOCALE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SET_LOCALE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SET_LOCALE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SET_IS_TOGGLE_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IS_EXPIRED_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return SET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SET_USERNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return SET_PHONE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return QUOTING_GOOGLE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return QUOTING_ADDRESS_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return QUOTING_ADDRESS_2; });
/* unused harmony export QUOTING_PRICE_VAN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return QUOTING_SET_VEHICLE_PRICE; });
/* unused harmony export QUOTING_PRICE_5TON */
/* unused harmony export QUOTING_PRICE_9TON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return QUOTING_IS_GET_QUOTE; });
/* unused harmony export QUOTING_SELECTED_VEHICLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IS_DRAGGING_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return QUOTING_IS_NO_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return ORDER_VEHICLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return ORDER_PASSENGER_COURT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return ORDER_TUNNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ORDER_PICKUP_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return ORDER_NEED_OVER_6FT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return ORDER_REMOVE_NET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ORDER_NEED_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ORDER_CART_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ORDER_NEED_CARRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ORDER_NEED_NEW_CAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ORDER_NEED_PET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ORDER_NEED_WASTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ORDER_PAY_BY_RECEIVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ORDER_ADD_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return ORDER_UPDATE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ORDER_ADD_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return ORDER_UPDATE_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ORDER_REMOVE_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ORDER_ID_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ORDER_PRICE_BREAKDOWN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ORDER_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return ORDER_REMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_CLICK_CONFIRM_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return IS_VALID_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_UPLOADED_ORDER_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return IS_SHOW_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IS_UPLOADED_CLIENT_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INIT_ORDER_DETAIL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return UPDATE_ORDER_DETAIL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ORDER_DETAIL_INFO; });
/* unused harmony export REMOVE_ORDER_DETAIL_INFO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return IS_SHOW_LOGIN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IS_SHOW_REGISTER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return IS_SHOW_UPDATE_USER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return IS_SHOW_CANCEL_ORDER_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IS_SHOW_CANCEL_ORDER_DIALOG_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return IS_SHOW_STAR_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IS_SHOW_BLACKLIST_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return IS_SHOW_REPORT_ISSUE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IS_SHOW_BONUS_PRICE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return IS_SHOW_EXTRA_MESSAGE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IS_SHOW_SMS_PHONE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return IS_SHOW_SMS_VERIFY_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return IS_SHOW_SMS_VERIFY_LOADING_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IS_SHOW_SIMPLE_MESSAGE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SET_SIMPLE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return IS_SHOW_AGREE_TO_RECEIVER_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_DRIVER_BLACKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IS_SENDING_SMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_DEFAULT_LANG; });
/* eslint-disable import/prefer-default-export */
var SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
var SET_LOCALE_START = 'SET_LOCALE_START';
var SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
var SET_LOCALE_ERROR = 'SET_LOCALE_ERROR'; // order action type

var SET_IS_TOGGLE_ON = 'SET_IS_TOGGLE_ON'; // Login action type

var LOGIN = 'LOGIN';
var IS_EXPIRED_LOGIN = 'IS_EXPIRED_LOGIN';
var SET_USER_INFO = 'SET_USER_INFO';
var REGISTER = 'REGISTER';
var SET_EMAIL = 'SET_EMAIL';
var SET_PASSWORD = 'SET_PASSWORD';
var SET_USERNAME = 'SET_USERNAME';
var SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
var SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES = 'SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES';
var SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES = 'SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES'; // Quoting

var QUOTING_GOOGLE_MAP = 'QUOTING_GOOGLE_MAP';
var QUOTING_ADDRESS_1 = 'QUOTING_ADDRESS_1';
var QUOTING_ADDRESS_2 = 'QUOTING_ADDRESS_2';
var QUOTING_PRICE_VAN = 'QUOTING_PRICE_VAN';
var QUOTING_SET_VEHICLE_PRICE = 'QUOTING_SET_VEHICLE_PRICE';
var QUOTING_PRICE_5TON = 'QUOTING_PRICE_5TON';
var QUOTING_PRICE_9TON = 'QUOTING_PRICE_9TON';
var QUOTING_IS_GET_QUOTE = 'QUOTING_IS_GET_QUOTE';
var QUOTING_SELECTED_VEHICLE = 'QUOTING_SELECTED_VEHICLE';
var IS_DRAGGING_MAP = 'IS_DRAGGING_MAP';
var QUOTING_IS_NO_SERVICE = 'QUOTING_IS_NO_SERVICE'; // Order

var ORDER_VEHICLE_TYPE = 'ORDER_VEHICLE_TYPE';
var ORDER_PASSENGER_COURT = 'ORDER_PASSENGER_COURT';
var ORDER_TUNNEL = 'ORDER_TUNNEL';
var ORDER_PICKUP_TIME = 'ORDER_PICKUP_TIME';
var ORDER_NEED_OVER_6FT = 'ORDER_NEED_OVER_6FT';
var ORDER_REMOVE_NET = 'ORDER_REMOVE_NET';
var ORDER_NEED_CART = 'ORDER_NEED_CART';
var ORDER_CART_COUNT = 'ORDER_CART_COUNT';
var ORDER_NEED_CARRY = 'ORDER_NEED_CARRY';
var ORDER_NEED_NEW_CAR = 'ORDER_NEED_NEW_CAR';
var ORDER_NEED_PET = 'ORDER_NEED_PET';
var ORDER_NEED_WASTE = 'ORDER_NEED_WASTE';
var ORDER_PAY_BY_RECEIVER = 'ORDER_PAY_BY_RECEIVER';
var ORDER_ADD_ADDRESS = 'ORDER_ADD_ADDRESS';
var ORDER_UPDATE_ADDRESS = 'ORDER_UPDATE_ADDRESS';
var ORDER_ADD_IMAGE = 'ORDER_ADD_IMAGE'; // add img and ready to upload to server

var ORDER_UPDATE_IMAGE = 'ORDER_UPDATE_IMAGE';
var ORDER_REMOVE_IMAGE = 'ORDER_REMOVE_IMAGE';
var ORDER_ID_DETAIL = 'ORDER_ID_DETAIL';
var ORDER_PRICE_BREAKDOWN_DETAIL = 'ORDER_PRICE_BREAKDOWN_DETAIL';
var ORDER_COUPON = 'ORDER_COUPON';
var ORDER_REMARK = 'ORDER_REMARK';
var IS_CLICK_CONFIRM_ORDER = 'IS_CLICK_CONFIRM_ORDER'; // confirm order and plan to preview order

var IS_VALID_ORDER = 'IS_VALID_ORDER'; // checking whether order is valid

var ADD_UPLOADED_ORDER_IMAGE = 'ADD_UPLOADED_ORDER_IMAGE'; // Uploaded img to server and get response

var IS_SHOW_COUPON = 'IS_SHOW_COUPON';
var IS_UPLOADED_CLIENT_PHOTO = 'IS_UPLOADED_CLIENT_PHOTO'; // check whether finish uploaded client photo
// Order Detail Info

var INIT_ORDER_DETAIL_INFO = 'INIT_ORDER_DETAIL_INFO';
var UPDATE_ORDER_DETAIL_INFO = 'UPDATE_ORDER_DETAIL_INFO';
var ADD_ORDER_DETAIL_INFO = 'ADD_ORDER_DETAIL_INFO';
var REMOVE_ORDER_DETAIL_INFO = 'REMOVE_ORDER_DETAIL_INFO'; // show popup modal in header for login/register/update user info

var IS_SHOW_LOGIN_MODAL = 'IS_SHOW_LOGIN_MODAL';
var IS_SHOW_REGISTER_MODAL = 'IS_SHOW_REGISTER_MODAL';
var IS_SHOW_UPDATE_USER_MODAL = 'IS_SHOW_UPDATE_USER_MODAL'; // dialog

var IS_SHOW_CANCEL_ORDER_DIALOG = 'IS_SHOW_CANCEL_ORDER_DIALOG';
var IS_SHOW_CANCEL_ORDER_DIALOG_ALERT = 'IS_SHOW_CANCEL_ORDER_DIALOG_ALERT';
var IS_SHOW_STAR_DIALOG = 'IS_SHOW_STAR_DIALOG';
var IS_SHOW_BLACKLIST_DIALOG = 'IS_SHOW_BLACKLIST_DIALOG';
var IS_SHOW_REPORT_ISSUE_DIALOG = 'IS_SHOW_REPORT_ISSUE_DIALOG';
var IS_SHOW_BONUS_PRICE_DIALOG = 'IS_SHOW_BONUS_PRICE_DIALOG';
var IS_SHOW_EXTRA_MESSAGE_DIALOG = 'IS_SHOW_EXTRA_MESSAGE_DIALOG';
var IS_SHOW_SMS_PHONE_DIALOG = 'IS_SHOW_SMS_PHONE_DIALOG';
var IS_SHOW_SMS_VERIFY_DIALOG = 'IS_SHOW_SMS_VERIFY_DIALOG';
var IS_SHOW_SMS_VERIFY_LOADING_DIALOG = 'IS_SHOW_SMS_VERIFY_LOADING_DIALOG';
var IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG = 'IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG';
var IS_SHOW_SIMPLE_MESSAGE_DIALOG = 'IS_SHOW_SIMPLE_MESSAGE_DIALOG';
var SET_SIMPLE_MESSAGE = 'SET_SIMPLE_MESSAGE';
var IS_SHOW_AGREE_TO_RECEIVER_DIALOG = 'IS_SHOW_AGREE_TO_RECEIVER_DIALOG'; // driver

var SET_DRIVER_BLACKLIST = 'SET_DRIVER_BLACKLIST'; // SMS

var IS_SENDING_SMS = 'IS_SENDING_SMS'; // Ensure current website lang is default lang

var IS_DEFAULT_LANG = 'IS_DEFAULT_LANG';

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(364);
// polyfills


function run() {
  // Run the application when both DOM is ready and page content is loaded
  if (['complete', 'loaded', 'interactive'].includes(document.readyState) && document.body) {
    Object(__WEBPACK_IMPORTED_MODULE_0__client__["a" /* default */])();
  } else {
    document.addEventListener('DOMContentLoaded', __WEBPACK_IMPORTED_MODULE_0__client__["a" /* default */], false);
  }
}

if (!global.Intl) {
  // You can show loading banner here
  __webpack_require__.e/* require.ensure */(7).then((function (require) {
    // and require them here
    __webpack_require__(157); // TODO: This is bad. You should only require one language dynamically

    /* @intl-code-template require('intl/locale-data/jsonp/${lang}.js'); */


    __webpack_require__(158);

    __webpack_require__(159);

    __webpack_require__(160);

    __webpack_require__(161);

    __webpack_require__(162);
    /* @intl-code-template-end */


    run();
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
} else {
  run();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31)))

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__(365);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(30);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(153);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(370);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(371);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/history/PathUtils.js
var PathUtils = __webpack_require__(101);
var PathUtils_default = /*#__PURE__*/__webpack_require__.n(PathUtils);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js
var index_es = __webpack_require__(102);

// EXTERNAL MODULE: ./node_modules/react-intl/locale-data/en.js
var en = __webpack_require__(395);
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./node_modules/react-intl/locale-data/sg.js
var sg = __webpack_require__(396);
var sg_default = /*#__PURE__*/__webpack_require__.n(sg);

// EXTERNAL MODULE: ./node_modules/react-intl/locale-data/zh.js
var zh = __webpack_require__(397);
var zh_default = /*#__PURE__*/__webpack_require__.n(zh);

// EXTERNAL MODULE: ./node_modules/react-intl/locale-data/ko.js
var ko = __webpack_require__(398);
var ko_default = /*#__PURE__*/__webpack_require__.n(ko);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(54);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(148);

// EXTERNAL MODULE: ./node_modules/react-apollo/react-apollo.browser.umd.js
var react_apollo_browser_umd = __webpack_require__(402);
var react_apollo_browser_umd_default = /*#__PURE__*/__webpack_require__.n(react_apollo_browser_umd);

// CONCATENATED MODULE: ./src/components/App.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */






var ContextType = _extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired,
  // Universal HTTP client
  fetch: prop_types_default.a.func.isRequired,
  pathname: prop_types_default.a.string.isRequired,
  query: prop_types_default.a.object
}, es["a" /* Provider */].childContextTypes, {
  // Apollo Client
  client: prop_types_default.a.object.isRequired,
  // ReactIntl
  intl: index_es["a" /* IntlProvider */].childContextTypes.intl,
  locale: prop_types_default.a.string
});
/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */


var App_App =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: "getChildContext",
    value: function getChildContext() {
      return this.props.context;
    } // NOTE: This methods are not needed if you update URL by setLocale action.
    //
    //  componentDidMount() {
    //    const store = this.props.context && this.props.context.store;
    //    if (store) {
    //      this.lastLocale = store.getState().intl.locale;
    //      this.unsubscribe = store.subscribe(() => {
    //        const state = store.getState();
    //        const { newLocale, locale } = state.intl;
    //        if (!newLocale && this.lastLocale !== locale) {
    //          this.lastLocale = locale;
    //          this.forceUpdate();
    //        }
    //      });
    //    }
    //  }
    //
    //  componentWillUnmount() {
    //    if (this.unsubscribe) {
    //      this.unsubscribe();
    //      this.unsubscribe = null;
    //    }
    //  }

  }, {
    key: "render",
    value: function render() {
      // Here, we are at universe level, sure? ;-)
      var client = this.props.context.client; // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.

      return _jsx(react_apollo_browser_umd["ApolloProvider"], {
        client: client
      }, void 0, this.props.children);
    }
  }]);

  return App;
}(react_default.a.PureComponent);

Object.defineProperty(App_App, "childContextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ContextType
});
/* harmony default export */ var components_App = (App_App);
// EXTERNAL MODULE: ./src/createFetch.js
var createFetch = __webpack_require__(152);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__(103);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var redux_thunk_lib = __webpack_require__(405);
var redux_thunk_lib_default = /*#__PURE__*/__webpack_require__.n(redux_thunk_lib);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(35);

// CONCATENATED MODULE: ./src/reducers/user.js
function user__extends() { user__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user__extends.apply(this, arguments); }


function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (state === null) {
    return {
      email: '',
      password: '',
      name: '',
      phone: '',
      has_agreed_to_receive_gogovan_updates: false,
      has_agreed_to_receive_third_parties_updates: false,
      user: null,
      isShowLoginModal: false,
      isShowRegisterModal: false,
      isShowUpdateUserModal: false,
      isShowExpiredLoginModal: false
    };
  }

  switch (action.type) {
    case constants["B" /* LOGIN */]:
      return user__extends({}, state, {
        email: action.payload.email,
        password: action.payload.password
      });

    case constants["_18" /* SET_USER_INFO */]:
      return user__extends({}, state, {
        user: action.payload
      });

    case constants["_4" /* REGISTER */]:
      return user__extends({}, state, {
        email: action.payload.email,
        password: action.payload.password,
        phone: action.payload.phone,
        name: action.payload.name
      });

    case constants["_6" /* SET_EMAIL */]:
      return user__extends({}, state, {
        email: action.payload
      });

    case constants["_13" /* SET_PASSWORD */]:
      return user__extends({}, state, {
        password: action.payload
      });

    case constants["_17" /* SET_USERNAME */]:
      return user__extends({}, state, {
        name: action.payload
      });

    case constants["_14" /* SET_PHONE_NUMBER */]:
      if (!Number.isNaN(parseInt(action.payload, 10))) {
        return user__extends({}, state, {
          phone: action.payload
        });
      }

      return user__extends({}, state);

    case constants["p" /* IS_SHOW_LOGIN_MODAL */]:
      return user__extends({}, state, {
        isShowLoginModal: !state.isShowLoginModal
      });

    case constants["q" /* IS_SHOW_REGISTER_MODAL */]:
      return user__extends({}, state, {
        isShowRegisterModal: !state.isShowRegisterModal
      });

    case constants["y" /* IS_SHOW_UPDATE_USER_MODAL */]:
      return user__extends({}, state, {
        isShowUpdateUserModal: !state.isShowUpdateUserModal
      });

    case constants["g" /* IS_EXPIRED_LOGIN */]:
      return user__extends({}, state, {
        isShowExpiredLoginModal: !state.isShowExpiredLoginModal
      });

    case constants["_7" /* SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES */]:
      return user__extends({}, state, {
        has_agreed_to_receive_gogovan_updates: !state.has_agreed_to_receive_gogovan_updates
      });

    case constants["_8" /* SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES */]:
      return user__extends({}, state, {
        has_agreed_to_receive_third_parties_updates: !state.has_agreed_to_receive_third_parties_updates
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/runtime.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function runtime__extends() { runtime__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return runtime__extends.apply(this, arguments); }


function runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case constants["_15" /* SET_RUNTIME_VARIABLE */]:
      return runtime__extends({}, state, _defineProperty({}, action.payload.name, action.payload.value));

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/intl.js
function intl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function intl__extends() { intl__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return intl__extends.apply(this, arguments); }


function intl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (state === null) {
    return {
      initialNow: Date.now(),
      defaultLocale: "zh-HK" || 'zh-HK',
      isDefaultLang: false
    }; // defaultLocale included {zh-HK, en-HK, zh-TW, en-IN, en-SG, ko-KR}
  }

  switch (action.type) {
    case constants["_11" /* SET_LOCALE_START */]:
      {
        var locale = state[action.payload.locale] ? action.payload.locale : state.locale;
        return intl__extends({}, state, {
          locale: locale,
          newLocale: action.payload.locale
        });
      }

    case constants["_12" /* SET_LOCALE_SUCCESS */]:
      {
        return intl__extends({}, state, {
          locale: action.payload.locale,
          newLocale: null,
          messages: intl__extends({}, state.messages, intl__defineProperty({}, action.payload.locale, action.payload.messages))
        });
      }

    case constants["_10" /* SET_LOCALE_ERROR */]:
      {
        return intl__extends({}, state, {
          newLocale: null
        });
      }

    case constants["e" /* IS_DEFAULT_LANG */]:
      {
        return intl__extends({}, state, {
          isDefaultLang: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
}
// EXTERNAL MODULE: ./node_modules/react-addons-update/index.js
var react_addons_update = __webpack_require__(107);
var react_addons_update_default = /*#__PURE__*/__webpack_require__.n(react_addons_update);

// CONCATENATED MODULE: ./src/reducers/order.js
function order__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function order__extends() { order__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return order__extends.apply(this, arguments); }



function order() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (state === null) {
    return {
      isToggleOn: true,
      address: [],
      images: [],
      vehicle: '',
      passenger_count: 0,
      tunnel: 'any',
      pickup_time: '0',
      need_over_6ft: false,
      cart_count: 1,
      need_cart: false,
      remove_net: 'half',
      need_carry: false,
      need_new_car: false,
      need_pet: false,
      need_waste: false,
      pay_by_receiver: false,
      order_id_detail: 0,
      driverBlacklistResponse: {},
      coupon_code: null,
      orderPriceBreakdownDetail: {
        extra_message: ''
      },
      remark: '',
      isClickConfirmOrder: false,
      isValidOrder: true,
      isShowCoupon: false,
      isUploadedClientPhoto: false,
      client_uploads: [],
      orderDetailInfo: {}
    };
  }

  switch (action.type) {
    case constants["_9" /* SET_IS_TOGGLE_ON */]:
      return order__extends({}, state, {
        isToggleOn: !state.isToggleOn
      });

    case constants["X" /* ORDER_VEHICLE_TYPE */]:
      return order__extends({}, state, {
        vehicle: action.payload
      });

    case constants["C" /* ORDER_ADD_ADDRESS */]:
      return order__extends({}, state, {
        address: _toConsumableArray(state.address).concat([action.payload])
      });

    case constants["V" /* ORDER_UPDATE_ADDRESS */]:
      return react_addons_update_default()(state, {
        address: order__defineProperty({}, action.index, {
          $set: action.payload
        })
      });

    case constants["D" /* ORDER_ADD_IMAGE */]:
      return order__extends({}, state, {
        images: _toConsumableArray(state.images).concat([action.payload])
      });

    case constants["W" /* ORDER_UPDATE_IMAGE */]:
      return react_addons_update_default()(state, {
        images: order__defineProperty({}, action.index, {
          $set: action.payload
        })
      });

    case constants["S" /* ORDER_REMOVE_IMAGE */]:
      return react_addons_update_default()(state, {
        images: {
          $splice: [[action.index, 1]]
        }
      });

    case constants["N" /* ORDER_PASSENGER_COURT */]:
      return order__extends({}, state, {
        passenger_count: action.payload
      });

    case constants["U" /* ORDER_TUNNEL */]:
      return order__extends({}, state, {
        tunnel: action.payload
      });

    case constants["P" /* ORDER_PICKUP_TIME */]:
      return order__extends({}, state, {
        pickup_time: action.payload
      });

    case constants["K" /* ORDER_NEED_OVER_6FT */]:
      return order__extends({}, state, {
        need_over_6ft: action.payload
      });

    case constants["T" /* ORDER_REMOVE_NET */]:
      return order__extends({}, state, {
        remove_net: action.payload
      });

    case constants["E" /* ORDER_CART_COUNT */]:
      return order__extends({}, state, {
        cart_count: action.payload
      });

    case constants["I" /* ORDER_NEED_CART */]:
      return order__extends({}, state, {
        need_cart: action.payload
      });

    case constants["H" /* ORDER_NEED_CARRY */]:
      return order__extends({}, state, {
        need_carry: action.payload
      });

    case constants["J" /* ORDER_NEED_NEW_CAR */]:
      return order__extends({}, state, {
        need_new_car: action.payload
      });

    case constants["L" /* ORDER_NEED_PET */]:
      return order__extends({}, state, {
        need_pet: action.payload
      });

    case constants["M" /* ORDER_NEED_WASTE */]:
      return order__extends({}, state, {
        need_waste: action.payload
      });

    case constants["O" /* ORDER_PAY_BY_RECEIVER */]:
      return order__extends({}, state, {
        pay_by_receiver: action.payload
      });

    case constants["G" /* ORDER_ID_DETAIL */]:
      return order__extends({}, state, {
        order_id_detail: action.payload
      });

    case constants["_5" /* SET_DRIVER_BLACKLIST */]:
      return order__extends({}, state, {
        driverBlacklistResponse: action.payload
      });

    case constants["Q" /* ORDER_PRICE_BREAKDOWN_DETAIL */]:
      return order__extends({}, state, {
        orderPriceBreakdownDetail: action.payload
      });

    case constants["R" /* ORDER_REMARK */]:
      return order__extends({}, state, {
        remark: action.payload
      });

    case constants["F" /* ORDER_COUPON */]:
      return order__extends({}, state, {
        coupon_code: action.payload
      });

    case constants["d" /* IS_CLICK_CONFIRM_ORDER */]:
      return order__extends({}, state, {
        isClickConfirmOrder: action.payload
      });

    case constants["A" /* IS_VALID_ORDER */]:
      return order__extends({}, state, {
        isValidOrder: action.payload
      });

    case constants["z" /* IS_UPLOADED_CLIENT_PHOTO */]:
      return order__extends({}, state, {
        isUploadedClientPhoto: action.payload
      });

    case constants["n" /* IS_SHOW_COUPON */]:
      return order__extends({}, state, {
        isShowCoupon: action.payload
      });

    case constants["c" /* INIT_ORDER_DETAIL_INFO */]:
      return react_addons_update_default()(state, {
        orderDetailInfo: {
          $set: action.payload
        }
      });

    case constants["b" /* ADD_UPLOADED_ORDER_IMAGE */]:
      return react_addons_update_default()(state, {
        client_uploads: {
          $push: action.payload
        }
      });

    case constants["_19" /* UPDATE_ORDER_DETAIL_INFO */]:
      // replace whole elements
      if (action.service === null) {
        return react_addons_update_default()(state, {
          orderDetailInfo: {
            $set: action.payload
          }
        });
      } else if (action.service2 === null) {
        return react_addons_update_default()(state, {
          orderDetailInfo: order__defineProperty({}, action.service, {
            $set: action.payload
          })
        });
      }

      return react_addons_update_default()(state, {
        orderDetailInfo: order__defineProperty({}, action.service, order__defineProperty({}, action.service2, {
          $set: action.payload
        }))
      });

    case constants["a" /* ADD_ORDER_DETAIL_INFO */]:
      return react_addons_update_default()(state, {
        orderDetailInfo: order__defineProperty({}, action.service, {
          $set: action.payload
        })
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/quoting.js
function quoting__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function quoting__extends() { quoting__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return quoting__extends.apply(this, arguments); }



function quoting() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (state === null) {
    return {
      map: null,
      isDraggingMap: false,
      address1: {
        address: '',
        lat: 0,
        lon: 0
      },
      address2: {
        address: '',
        lat: 0,
        lon: 0
      },
      vehiclePrice: {},
      isGetQuote: false,
      isNoQuotingService: false
    };
  }

  switch (action.type) {
    case constants["_0" /* QUOTING_GOOGLE_MAP */]:
      return quoting__extends({}, state, {
        map: action.payload
      });

    case constants["f" /* IS_DRAGGING_MAP */]:
      return quoting__extends({}, state, {
        isDraggingMap: action.payload
      });

    case constants["Y" /* QUOTING_ADDRESS_1 */]:
      return quoting__extends({}, state, {
        address1: action.payload
      });

    case constants["Z" /* QUOTING_ADDRESS_2 */]:
      return quoting__extends({}, state, {
        address2: action.payload
      });

    case constants["_1" /* QUOTING_IS_GET_QUOTE */]:
      return quoting__extends({}, state, {
        isGetQuote: action.payload
      });

    case constants["_2" /* QUOTING_IS_NO_SERVICE */]:
      return quoting__extends({}, state, {
        isNoQuotingService: action.payload
      });

    case constants["_3" /* QUOTING_SET_VEHICLE_PRICE */]:
      return react_addons_update_default()(state, {
        vehiclePrice: quoting__defineProperty({}, action.vehicle, {
          $set: action.price
        })
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/dialog.js
function dialog__extends() { dialog__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dialog__extends.apply(this, arguments); }


function dialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (state === null) {
    return {
      isShowCancelOrderModal: false,
      isShowCancelOrderAlert: false,
      isShowStarDialog: false,
      isShowBlacklistDialog: false,
      isShowReportIssueDialog: false,
      isShowBonusPriceDialog: false,
      isShowExtraMessageDialog: false,
      isShowSMSPhoneDialog: false,
      isShowSMSVerifyDialog: false,
      isShowSMSVerifyLoadingDialog: false,
      isShowSMSVerifySuccessDialog: false,
      isShowSimpleMessageDialog: false,
      setIsShowAgreeToReceiveDialog: false,
      simpleMessage: {
        header: '',
        body: ''
      },
      // SMS
      isSendingSMS: false
    };
  }

  switch (action.type) {
    case constants["l" /* IS_SHOW_CANCEL_ORDER_DIALOG */]:
      return dialog__extends({}, state, {
        isShowCancelOrderModal: !state.isShowCancelOrderModal
      });

    case constants["m" /* IS_SHOW_CANCEL_ORDER_DIALOG_ALERT */]:
      return dialog__extends({}, state, {
        isShowCancelOrderAlert: !state.isShowCancelOrderAlert
      });

    case constants["x" /* IS_SHOW_STAR_DIALOG */]:
      return dialog__extends({}, state, {
        isShowStarDialog: !state.isShowStarDialog
      });

    case constants["j" /* IS_SHOW_BLACKLIST_DIALOG */]:
      return dialog__extends({}, state, {
        isShowBlacklistDialog: !state.isShowBlacklistDialog
      });

    case constants["r" /* IS_SHOW_REPORT_ISSUE_DIALOG */]:
      return dialog__extends({}, state, {
        isShowReportIssueDialog: !state.isShowReportIssueDialog
      });

    case constants["k" /* IS_SHOW_BONUS_PRICE_DIALOG */]:
      return dialog__extends({}, state, {
        isShowBonusPriceDialog: !state.isShowBonusPriceDialog
      });

    case constants["o" /* IS_SHOW_EXTRA_MESSAGE_DIALOG */]:
      return dialog__extends({}, state, {
        isShowExtraMessageDialog: !state.isShowExtraMessageDialog
      });

    case constants["t" /* IS_SHOW_SMS_PHONE_DIALOG */]:
      return dialog__extends({}, state, {
        isShowSMSPhoneDialog: !state.isShowSMSPhoneDialog
      });

    case constants["u" /* IS_SHOW_SMS_VERIFY_DIALOG */]:
      return dialog__extends({}, state, {
        isShowSMSVerifyDialog: !state.isShowSMSVerifyDialog
      });

    case constants["h" /* IS_SENDING_SMS */]:
      return dialog__extends({}, state, {
        isSendingSMS: action.payload
      });

    case constants["v" /* IS_SHOW_SMS_VERIFY_LOADING_DIALOG */]:
      return dialog__extends({}, state, {
        isShowSMSVerifyLoadingDialog: !state.isShowSMSVerifyLoadingDialog
      });

    case constants["w" /* IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG */]:
      return dialog__extends({}, state, {
        isShowSMSVerifySuccessDialog: !state.isShowSMSVerifySuccessDialog
      });

    case constants["s" /* IS_SHOW_SIMPLE_MESSAGE_DIALOG */]:
      return dialog__extends({}, state, {
        isShowSimpleMessageDialog: !state.isShowSimpleMessageDialog
      });

    case constants["_16" /* SET_SIMPLE_MESSAGE */]:
      return dialog__extends({}, state, {
        simpleMessage: action.payload
      });

    case constants["i" /* IS_SHOW_AGREE_TO_RECEIVER_DIALOG */]:
      return dialog__extends({}, state, {
        setIsShowAgreeToReceiveDialog: !state.setIsShowAgreeToReceiveDialog
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/index.js
 // import { persistReducer } from 'redux-persist';
// import storageSession from 'redux-persist/lib/storage/session';







function createRootReducer() {
  return Object(redux_es["c" /* combineReducers */])({
    user: user,
    runtime: runtime,
    intl: intl,
    order: order,
    quoting: quoting,
    dialog: dialog
  });
}
// CONCATENATED MODULE: ./src/store/createHelpers.js
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

var graphqlRequestDeprecatedMessage = "`graphqlRequest` has been deprecated.\nYou should use Apollo: `client.query({ query, variables...})` or `client.mutate()`\nDon't forget to enclose your query to gql`\u2026` tag or import *.graphql file.\nSee docs at http://dev.apollodata.com/core/apollo-client-api.html#ApolloClient\\.query";

function createGraphqlRequest(apolloClient) {
  return (
    /*#__PURE__*/
    function () {
      var _graphqlRequest = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(queryOrString, variables) {
        var query, gql, isMutation;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (false) {
                  // eslint-disable-next-line no-console
                  console.error(graphqlRequestDeprecatedMessage);
                } // const { skipCache } = options;


                query = queryOrString;

                if (!(typeof queryOrString === 'string')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return __webpack_require__.e/* require.ensure */(6).then((function (require) {
                  return __webpack_require__(2033);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

              case 5:
                gql = _context.sent;
                query = gql([queryOrString]);

              case 7:
                isMutation = false;

                if (query.definitions) {
                  isMutation = query.definitions.some(function (definition) {
                    return definition && definition.operation === 'mutation';
                  });
                }

                if (!isMutation) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", apolloClient.mutate({
                  mutation: query,
                  variables: variables
                }));

              case 11:
                return _context.abrupt("return", apolloClient.query({
                  query: query,
                  variables: variables
                }));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function graphqlRequest(_x, _x2) {
        return _graphqlRequest.apply(this, arguments);
      };
    }()
  );
}

function createHelpers(_ref) {
  var apolloClient = _ref.apolloClient,
      fetch = _ref.fetch,
      history = _ref.history;
  return {
    client: apolloClient,
    history: history,
    fetch: fetch,
    // @deprecated('Use `client` instead')
    apolloClient: apolloClient,
    // @deprecated('Use `client.query()` or `client.mutate()` instead')
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(406);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ./src/store/logger/logger.client.js

function logger_client_createLogger() {
  return Object(redux_logger["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js





function configureStore(initialState, helpersConfig) {
  var helpers = createHelpers(helpersConfig);
  var middleware = [redux_thunk_lib_default.a.withExtraArgument(helpers)];
  var enhancer;

  if (false) {
    middleware.push(createLogger()); // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension

    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };

    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(void 0, middleware), devToolsExtension);
  } else {
    enhancer = redux_es["a" /* applyMiddleware */].apply(void 0, middleware);
  }

  var rootReducer = createRootReducer(); // See https://github.com/reactjs/redux/releases/tag/v3.1.0

  var store = Object(redux_es["d" /* createStore */])(rootReducer, initialState, enhancer); // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)

  if (false) {
    module.hot.accept('../reducers', function () {
      return (// Don't forget to remove `()` if you change reducers back to normal rootReducer.
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default())
      );
    });
  }

  return store;
}
// CONCATENATED MODULE: ./src/DOMUtils.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector("".concat(tagName, "[").concat(keyName, "=\"").concat(keyValue, "\"]"));
  if (node && node.getAttribute(attrName) === attrValue) return; // Remove and create a new tag in order to make it work with bookmarks in Safari

  if (node) {
    node.parentNode.removeChild(node);
  }

  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}
function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}
function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}
function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}
// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(154);

// EXTERNAL MODULE: ./node_modules/apollo-client/index.js + 13 modules
var apollo_client = __webpack_require__(413);

// EXTERNAL MODULE: ./node_modules/apollo-link/lib/index.js + 2 modules
var apollo_link_lib = __webpack_require__(34);

// EXTERNAL MODULE: ./node_modules/apollo-link-error/lib/index.js
var apollo_link_error_lib = __webpack_require__(417);

// EXTERNAL MODULE: ./node_modules/apollo-link-http/lib/index.js + 1 modules
var apollo_link_http_lib = __webpack_require__(418);

// EXTERNAL MODULE: ./node_modules/apollo-link-logger/es/index.js
var apollo_link_logger_es = __webpack_require__(419);
var es_default = /*#__PURE__*/__webpack_require__.n(apollo_link_logger_es);

// EXTERNAL MODULE: ./node_modules/apollo-cache-inmemory/lib/index.js + 13 modules
var apollo_cache_inmemory_lib = __webpack_require__(422);

// CONCATENATED MODULE: ./src/core/createApolloClient/createCache.js


function dataIdFromObject(obj) {
  switch (obj.__typename) {
    case 'IntlMessage':
      // Do not use id as identifier for message because it's not unique between languages
      // instead instruct cache to build path and index identifier for cache key
      return null;

    case 'NewsItem':
      return obj.link ? "NewsItem:".concat(obj.link) : Object(apollo_cache_inmemory_lib["b" /* defaultDataIdFromObject */])(obj);

    default:
      return Object(apollo_cache_inmemory_lib["b" /* defaultDataIdFromObject */])(obj);
  }
}

function createCache() {
  // https://www.apollographql.com/docs/react/basics/caching.html#configuration
  return new apollo_cache_inmemory_lib["a" /* InMemoryCache */]({
    dataIdFromObject: dataIdFromObject
  });
}
// CONCATENATED MODULE: ./src/core/createApolloClient/createApolloClient.client.js
function createApolloClient_client__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var createApolloClient_client_link = Object(apollo_link_lib["from"])([Object(apollo_link_error_lib["a" /* onError */])(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;
  if (graphQLErrors) graphQLErrors.map(function (_ref2) {
    var message = _ref2.message,
        locations = _ref2.locations,
        path = _ref2.path;
    return console.warn("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
  });
  if (networkError) console.warn("[Network error]: ".concat(networkError));
})].concat(createApolloClient_client__toConsumableArray( false ? [apolloLogger] : []), [new apollo_link_http_lib["a" /* HttpLink */]({
  uri: '/graphql',
  credentials: 'include'
})]));
var cache = createCache();
function createApolloClient() {
  return new apollo_client["a" /* ApolloClient */]({
    link: createApolloClient_client_link,
    cache: cache.restore(window.App.apolloState),
    queryDeduplication: true,
    connectToDevTools: true
  });
}
// EXTERNAL MODULE: ./node_modules/universal-router/browser.mjs
var browser = __webpack_require__(423);

// EXTERNAL MODULE: ./src/service/auth.js
var auth = __webpack_require__(149);

// CONCATENATED MODULE: ./src/routes/index.js
function routes__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function _sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _slicedToArray(arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return _sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }



var getLanguageUrl = function getLanguageUrl() {
  var currentLocale = "zh-HK" || 'zh-HK';

  var _currentLocale$toLowe = currentLocale.toLowerCase().split('-'),
      _currentLocale$toLowe2 = _slicedToArray(_currentLocale$toLowe, 2),
      lang = _currentLocale$toLowe2[0],
      country = _currentLocale$toLowe2[1];

  return country === 'hk' && lang === 'en' ? "/".concat(lang) : '';
};

var routes_redirectToLoginPageIfLoggedOut = function redirectToLoginPageIfLoggedOut() {
  var isLoggedOut = !Object(auth["b" /* getAuth */])();

  if (true && isLoggedOut) {
    window.location.href = "".concat(getLanguageUrl(), "/login");
  }
};

var routes_redirectToOrderPageIfLoggedIn = function redirectToOrderPageIfLoggedIn() {
  var isLoggedIn = Object(auth["b" /* getAuth */])();

  if (true && isLoggedIn) {
    window.location.href = "".concat(getLanguageUrl(), "/order");
  }
}; // The top-level (parent) route


var routes = {
  path: '',
  // Keep in mind, routes are evaluated in order
  children: [{
    path: ['/order', '/en/order'],
    load: function load() {
      routes_redirectToLoginPageIfLoggedOut();
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2034));
    }
  }, {
    path: ['/show', '/en/show'],
    load: function load() {
      routes_redirectToLoginPageIfLoggedOut();
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2035));
    }
  }, {
    path: ['/dashboard', '/en/dashboard'],
    load: function load() {
      routes_redirectToLoginPageIfLoggedOut();
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2036));
    }
  }, {
    path: ['/login', '/en/login'],
    load: function load() {
      routes_redirectToOrderPageIfLoggedIn();
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2037));
    }
  }, {
    path: ['/signup', '/en/signup'],
    load: function load() {
      routes_redirectToOrderPageIfLoggedIn();
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2038));
    }
  }, // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
  {
    path: '(.*)',
    load: function load() {
      routes_redirectToOrderPageIfLoggedIn();
      routes_redirectToLoginPageIfLoggedOut();
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2039));
    }
  }],
  action: function () {
    var _action = routes__asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var next, route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              next = _ref.next;
              _context.next = 3;
              return next();

            case 3:
              route = _context.sent;
              return _context.abrupt("return", route);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function action(_x) {
      return _action.apply(this, arguments);
    };
  }()
}; // The error page is available by permanent url for development mode

if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var src_routes = (routes);
// CONCATENATED MODULE: ./src/router.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


/* harmony default export */ var router = (new browser["a" /* default */](src_routes, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }

    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }

    return undefined;
  }
}));
// EXTERNAL MODULE: ./src/actions/intl.js
var actions_intl = __webpack_require__(156);

// EXTERNAL MODULE: ./node_modules/bugsnag-js/dist/bugsnag.js
var bugsnag = __webpack_require__(437);
var bugsnag_default = /*#__PURE__*/__webpack_require__.n(bugsnag);

// EXTERNAL MODULE: ./node_modules/bugsnag-react/dist/bugsnag-react.js
var bugsnag_react = __webpack_require__(438);
var bugsnag_react_default = /*#__PURE__*/__webpack_require__.n(bugsnag_react);

// CONCATENATED MODULE: ./src/components/BugsnagErrorBoundary/BugsnagErrorBoundary.js



var BUGSNAG_KEY = "8038805f4ec86a95f3d5753f0d4717b8";
var DEFAULTLOCALE = "zh-HK";
var DEPLOYMENT_ENV = "prod";
var APP_VERSION = "2022-07-06T05:35:45.673Z";
var bugsnagClient = true && BUGSNAG_KEY ? bugsnag_default()({
  apiKey: BUGSNAG_KEY,
  appVersion: APP_VERSION,
  notifyReleaseStages: ['stag', 'prod'],
  releaseStage: DEPLOYMENT_ENV,
  metaData: {
    locale: DEFAULTLOCALE
  }
}) : null;
var BugsnagErrorBoundary = bugsnagClient ? bugsnagClient.use(bugsnag_react_default()(react_default.a)) : react_default.a.Fragment;
/* harmony default export */ var BugsnagErrorBoundary_BugsnagErrorBoundary = (BugsnagErrorBoundary);
// CONCATENATED MODULE: ./src/components/BugsnagErrorBoundary/index.js

// CONCATENATED MODULE: ./src/client.js
/* harmony export (immutable) */ __webpack_exports__["a"] = main;
var client_REACT_ELEMENT_TYPE;

function client__jsx(type, props, key, children) { if (!client_REACT_ELEMENT_TYPE) { client_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: client_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function client__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */






 // This is so bad: requiring all locale if they are not needed?

/* @intl-code-template import ${lang} from 'react-intl/locale-data/${lang}'; */





/* @intl-code-template-end */










/* @intl-code-template addLocaleData(${lang}); */

Object(index_es["b" /* addLocaleData */])(en_default.a);
Object(index_es["b" /* addLocaleData */])(sg_default.a);
Object(index_es["b" /* addLocaleData */])(zh_default.a);
Object(index_es["b" /* addLocaleData */])(ko_default.a);
/* @intl-code-template-end */
// Universal HTTP client

var client_fetch = Object(createFetch["a" /* default */])({
  baseUrl: window.App.apiUrl
});
var apolloClient = createApolloClient(); // Initialize a new Redux store
// http://redux.js.org/docs/basics/UsageWithReact.html

var client_store = configureStore(window.App.state, {
  apolloClient: apolloClient,
  fetch: client_fetch,
  history: src_history["a" /* default */]
}); // Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html

var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // For react-apollo
  client: apolloClient,
  store: client_store,
  storeSubscription: null,
  // Universal HTTP client
  fetch: client_fetch,
  // intl instance as it can be get with injectIntl
  intl: client_store.dispatch(Object(actions_intl["a" /* getIntl */])())
};
var container = document.getElementById('app');
var currentLocation = src_history["a" /* default */].location;
var appInstance;
var scrollPositionsHistory = {}; // Re-render the app when window.location changes

function onLocationChange(_x, _x2) {
  return _onLocationChange.apply(this, arguments);
}

function _onLocationChange() {
  _onLocationChange = client__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(location, action) {
    var isInitialRender, route, renderReactApp;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            }; // Delete stored scroll position for next page if any

            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }

            currentLocation = location;
            context.intl = client_store.dispatch(Object(actions_intl["a" /* getIntl */])());
            isInitialRender = !action;
            _context.prev = 5;
            context.pathname = location.pathname;
            context.query = query_string_default.a.parse(location.search);
            context.locale = client_store.getState().intl.locale; // Traverses the list of routes in the order they are defined until
            // it finds the first route that matches provided URL path string
            // and whose action method returns anything other than `undefined`.

            _context.next = 11;
            return router.resolve(context);

          case 11:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return");

          case 14:
            if (!route.redirect) {
              _context.next = 17;
              break;
            }

            src_history["a" /* default */].replace(route.redirect);
            return _context.abrupt("return");

          case 17:
            renderReactApp = isInitialRender ? react_dom_default.a.hydrate : react_dom_default.a.render;
            appInstance = renderReactApp(client__jsx(BugsnagErrorBoundary_BugsnagErrorBoundary, {}, void 0, client__jsx(components_App, {
              context: context
            }, void 0, route.component)), container, function () {
              if (isInitialRender) {
                // Switch off the native scroll restoration behavior and handle it manually
                // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
                if (window.history && 'scrollRestoration' in window.history) {
                  window.history.scrollRestoration = 'manual';
                }

                var elem = document.getElementById('css');
                if (elem) elem.parentNode.removeChild(elem);
                return;
              } // document.title = route.title;


              updateMeta('description', route.description); // Update necessary tags in <head> at runtime here, ie:
              // updateMeta('keywords', route.keywords);
              // updateCustomMeta('og:url', route.canonicalUrl);
              // updateCustomMeta('og:image', route.imageUrl);
              // updateLink('canonical', route.canonicalUrl);
              // etc.

              var scrollX = 0;
              var scrollY = 0;
              var pos = scrollPositionsHistory[location.key];

              if (pos) {
                scrollX = pos.scrollX;
                scrollY = pos.scrollY;
              } else {
                var targetHash = location.hash.substr(1);

                if (targetHash) {
                  var target = document.getElementById(targetHash);

                  if (target) {
                    scrollY = window.pageYOffset + target.getBoundingClientRect().top;
                  }
                }
              } // Restore the scroll position if it was saved into the state
              // or scroll to the given #hash anchor
              // or scroll to top of the page


              window.scrollTo(scrollX, scrollY); // Google Analytics tracking. Don't send 'pageview' event after
              // the initial rendering, as it was already sent

              if (window.ga) {
                window.ga('send', 'pageview', Object(PathUtils["createPath"])(location));
              }
            });
            _context.next = 27;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](5);

            if (true) {
              _context.next = 25;
              break;
            }

            throw _context.t0;

          case 25:
            console.error(_context.t0); // Do a full page reload if error occurs during client-side navigation

            if (!isInitialRender && currentLocation.key === location.key) {
              console.error('RSK will reload your page after error');
              window.location.reload();
            }

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[5, 21]]);
  }));
  return _onLocationChange.apply(this, arguments);
}

var isHistoryObserved = false;
function main() {
  // Handle client-side navigation by using HTML5 History API
  // For more information visit https://github.com/mjackson/history#readme
  currentLocation = src_history["a" /* default */].location;

  if (!isHistoryObserved) {
    isHistoryObserved = true;
    src_history["a" /* default */].listen(onLocationChange);
  }

  onLocationChange(currentLocation);
} // globally accesible entry point

window.RSK_ENTRY = main; // Enable Hot Module Replacement (HMR)

if (false) {
  module.hot.accept('./router', function () {
    if (appInstance && appInstance.updater.isMounted(appInstance)) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 436:
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"intl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":null}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"intl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"message"},"arguments":[],"directives":[],"selectionSet":null}]}}]}}],"loc":{"start":0,"end":82}};
    doc.loc.source = {"body":"query intl($locale: String!) {\n  intl(locale: $locale) {\n    id\n    message\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ })

},[163]);


// WEBPACK FOOTER //
// client.e8afeb7b.js